import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthenticationService, ToastService } from '../services';
import { Observable, map, take } from 'rxjs';

export const canActivateSignIn = (
    activatedrouter: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
): boolean | UrlTree | Promise<boolean | UrlTree> | Observable<boolean | UrlTree> => {
    const authenticationService = inject(AuthenticationService);
    const router = inject(Router);

    return authenticationService.currentUser.pipe(take(1), map((user) => {
        const loggedIn = !!user && !!localStorage.getItem('access_token');

        // Not signed in → show the login / register page.
        if (!loggedIn) {
            return true;
        }

        // Only the sign-in / sign-up pages bounce a signed-in user. Public
        // forms under /auth (walk-in CV upload link, sales application,
        // reset password) must still open for anyone.
        const path = (state.url || '').split('?')[0].replace(/\/+$/, '');
        const signInPages = ['/auth', '/auth/sign-in', '/auth/login', '/auth/emp-login',
            '/auth/sign-in', '/auth/register', '/auth/emp-register'];
        if (!signInPages.includes(path)) {
            return true;
        }

        // Already signed in (token still valid) → straight to the default page
        // for their role instead of the login page (or the blank root page).
        const home = authenticationService.roleHomeUrl();
        return home ? router.createUrlTree([home]) : true;
    }));
};
